//Components
import Navbar from "../../components/Navbar";
import SliderSection from "../../components/SliderSection";
import ApplyNowSiderSection from "../../components/ApplyNowSiderSection";
import RailOfFutureSection from "../../components/RailOfFutureSection";
import BannerSection from "../../components/BannerSection";
import WhoCanJoinSection from "../../components/WhoCanJoinSection";
import TimelineSection from "../../components/TimelineSection";
import WhatAwaitsYouSection from "../../components/WhatAwaitsYouSection";
import FAQSection from "../../components/FAQSection";
import AboutRayInsurance from "../../components/AboutRayInsurance";
import ApplicationForm from "../../components/ApplicationForm";
import FooterSection from "../../components/FooterSection";

const Main = () => {
  return (
    <>
      <Navbar />
      <SliderSection />
      <ApplyNowSiderSection />
      <RailOfFutureSection />
      <BannerSection />
      <WhoCanJoinSection />
      <TimelineSection />
      <WhatAwaitsYouSection />
      <FAQSection />
      <AboutRayInsurance />
      <ApplicationForm />
      <FooterSection />
    </>
  );
};
export default Main;
